import { compare } from "./Utils-Numeric.mjs";

/**
 * Count how many times an element is present in a array
 * @param array
 * @param element element to count in array
 * @returns integer
 */
export function countSameElementList(array, element) {
  return array.filter((item) => compare("==", item, element)).length;
}

/**
 * Delete duplicates in a list (). For each element, test if other elements are equivalent (if Math.Js element use math.equal,
 * if standard object compare ref).
 * Algo : start by empty new array "unique" then for each orginal array's element if it doesn't already exist in new array "unique" I push it into unique
 * @param array
 * @returns the list without duplicates //ES6 has a native object Set to store unique values.
 */
export function deleteDuplicates(array) {
  var unique = [];
  array.forEach((object) => {
    if (
      !unique.some(
        (secondObject) => compare("==", object, secondObject) //equal (custom function based on mathjsfunctions) to compare as math values
      )
    ) {
      unique.push(object);
    }
  });
  return unique;
}

/**
 * Compare value depending on its type and filter it if equal
 * Same approach than deleteDuplicates function
 * @param array
 * @param value_var
 */
export function deleteElementList(array, value) {
  var newArray = [];
  array.forEach((object, index) => {
    //console.log(math.typeOf(object), object, value);
    try {
      if (!compare("==", object, value)) {
        newArray.push(object);
      }
    } catch (e) {
      console.log(
        "Catch deleteElementList : two objects compared have not the same type"
      );
      newArray.push(object);
    }
  });
  console.log(array, newArray);
  return newArray;
}
/**
 * Shuffle elements in a Array
 * @param array
 */
export function shuffleList(array) {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}
/**
 * Generates a List of random elements given by the callbackFunction
 * @param length
 * @param callbackFunction
 * @returns
 */
export function randomList(length, callbackFunction) {
  return Array(math.number(length)) // convert into std js number (and round it) otherwise mathjs numbers don't work (a random list with 2+2 block always return 1)
    .fill()
    .map(() => callbackFunction());
}

/**
 * Return the number of elements in common between an array and a map by the reference/key
 * @param keysArray array that contains the keys of the displayes elements
 * @param solutionMap map that contains all the good answers
 * @returns {Number}
 */
export function getNbOfElementsInCommonArrayMap(keysArray, solutionMap) {
  var nbInCommon = 0;
  var mapEntries = solutionMap.keys();

  for (let j = 0; j < solutionMap.size; j++) {
    var instanceMap = mapEntries.next().value;
    for (let i in keysArray) {
      if (keysArray[i] == instanceMap) {
        nbInCommon++;
      }
    }
  }

  return nbInCommon;
}

//The de-facto unbiased shuffle algorithm is the Fisher-Yates (aka Knuth) Shuffle.
export function shuffleArray(array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;
  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

export function randomElementsFromArray(population, k, keepOrder = true) {
  /*
        Chooses k unique random elements from a population sequence or set.

        Returns a new list containing elements from the population while
        leaving the original population unchanged.  The resulting list is
        in selection order so that all sub-slices will also be valid random
        samples.  This allows raffle winners (the sample) to be partitioned
        into grand prize and second place winners (the subslices).

        Members of the population need not be hashable or unique.  If the
        population contains repeats, then each occurrence is a possible
        selection in the sample.

        To choose a sample in a range of integers, use range as an argument.
        This is especially fast and space efficient for sampling from a
        large population:   sample(range(10000000), 60)

        Sampling without replacement entails tracking either potential
        selections (the pool) in a list or previous selections in a set.

        When the number of selections is small compared to the
        population, then tracking selections is efficient, requiring
        only a small set and an occasional reselection.  For
        a larger number of selections, the pool tracking method is
        preferred since the list takes less space than the
        set and it doesn't suffer from frequent reselections.
    */

  if (!Array.isArray(population))
    throw new TypeError("Population must be an array.");
  var n = population.length;
  if (k < 0 || k > n)
    throw new RangeError("Sample larger than population or is negative");

  var result = new Array(k);
  var setsize = 21; // size of a small set minus size of an empty list

  if (k > 5) setsize += Math.pow(4, Math.ceil(Math.log(k * 3) / Math.log(4)));

  if (n <= setsize) {
    // An n-length list is smaller than a k-length set
    var pool = population.slice();
    for (var i = 0; i < k; i++) {
      // invariant:  non-selected at [0,n-i)
      var j = (Math.random() * (n - i)) | 0;
      result[i] = pool[j];
      pool[j] = pool[n - i - 1]; // move non-selected item into vacancy
    }
  } else {
    var selected = new Set();
    for (var i = 0; i < k; i++) {
      var j = (Math.random() * n) | 0;
      while (selected.has(j)) {
        j = (Math.random() * n) | 0;
      }
      selected.add(j);
      result[i] = population[j];
    }
  }
  if (keepOrder) {
    result.sort(function (a, b) {
      return population.indexOf(a) - population.indexOf(b);
    });
  }
  return result;
}
